//
//
//
//

export default {
  name: 'ReadTime',

  props: ['content'],

  computed: {
    readTime() {
      let minutes = 0
      const contentText = JSON.stringify(this.content)
      const words = contentText.split(' ').length
      const wordsPerMinute = 200
      minutes = Math.ceil(words / wordsPerMinute)
      return minutes
    },
  },
}
